import { Lock, ShieldCheck, EyeOff, HeartHandshake } from "lucide-react";
import { useMLO } from "@/lib/mloContext";
import { CONTACT } from "@/lib/constants";

export default function PrivacyTrust() {
  const mlo = useMLO();
  const full = mlo?.name || CONTACT.loanOfficer;
  const nmls = mlo?.nmls || CONTACT.nmls;
  const items = [
    {
      icon: <Lock size={22} strokeWidth={1.75} />,
      title: "Encrypted end-to-end",
      body: "All information you share travels over TLS 1.2+ and is stored with bank-grade encryption at rest.",
    },
    {
      icon: <EyeOff size={22} strokeWidth={1.75} />,
      title: "We never sell your data",
      body: "You won't get flooded with calls from random lenders. Your info is used solely to prepare your rate scenarios.",
    },
    {
      icon: <ShieldCheck size={22} strokeWidth={1.75} />,
      title: "Licensed & regulated",
      body: `${full} (NMLS #${nmls}) originates through NEXA Lending (NMLS #${CONTACT.companyNmls}), an Equal Housing Lender.`,
    },
    {
      icon: <HeartHandshake size={22} strokeWidth={1.75} />,
      title: "No-pressure conversations",
      body: "Not the right time? No problem. We'll be here whenever you're ready to compare rates again.",
    },
  ];
  return (
    <section data-testid="privacy-section" className="section-y bg-linen">
      <div className="container-grc">
        <div className="max-w-3xl">
          <p className="text-xs font-bold tracking-[0.22em] uppercase text-teal">
            Privacy & trust
          </p>
          <h2 className="mt-4 font-heading font-medium text-4xl sm:text-5xl text-balance">
            Your information deserves the same care as your <span className="italic text-teal">home</span>.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`privacy-card-${i}`}
              className="rounded-2xl bg-white border border-linen-border p-6 shadow-soft hover:shadow-lift transition-shadow"
            >
              <div className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-teal-light text-teal">
                {it.icon}
              </div>
              <h3 className="mt-5 font-heading font-medium text-lg">{it.title}</h3>
              <p className="mt-2 text-sm text-ink-600 leading-relaxed">{it.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
